import { getContext } from '@/context';
import { FREE_PASS_API_URL } from '@/consts/urls';
import { isPortfolioApp } from '@/utils/environment/surface';
import { FreePassError, FreePassErrorReasons } from './freePassError';

const buildHeaders = (): Record<string, string> => ({
  'Content-Type': 'application/json',
  ...(isPortfolioApp() ? { 'x-promo-app': 'gen-ai-platform-app' } : {}),
});

const freePassFetch = async <TResponse>(
  path: string,
  options: { method?: 'GET' | 'POST'; body?: unknown } = {}
): Promise<TResponse> => {
  if (!FREE_PASS_API_URL) throw new FreePassError(FreePassErrorReasons.Unknown);

  const { method = 'GET', body } = options;

  const response = await getContext().utils.api.fetch(
    `${FREE_PASS_API_URL}/free-pass${path}`,
    {
      method,
      headers: buildHeaders(),
      ...(body ? { body: JSON.stringify(body) } : {}),
    }
  );

  let data;
  try {
    data = await response.json();
  } catch {
    throw new FreePassError(FreePassErrorReasons.Unknown);
  }

  if (data?.status === 'error' || !response.ok) {
    throw new FreePassError(data?.reason ?? FreePassErrorReasons.Unknown);
  }
  if (data?.status === 'success') return data.response as TResponse;
  // Some deployments return the payload without the success envelope.
  if (data != null) return data as TResponse;
  throw new FreePassError(FreePassErrorReasons.Unknown);
};

export default freePassFetch;
